interface Props {
  value: number; // 0-100
  size?: number;
  stroke?: number;
  label?: string;
}

/** Conic ribbon ring around a numeric score. */
export function ReliabilityRing({ value, size = 88, stroke = 8, label }: Props) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  const dash = (pct / 100) * c;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={`ring-${size}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="hsl(var(--krew-lime))" />
            <stop offset="50%" stopColor="hsl(var(--krew-cyan))" />
            <stop offset="100%" stopColor="hsl(var(--krew-magenta))" />
          </linearGradient>
        </defs>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth={stroke} opacity={0.35} />
        <circle
          cx={size/2} cy={size/2} r={r}
          fill="none"
          stroke={`url(#ring-${size})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 600ms cubic-bezier(0.2,0.7,0.2,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-2xl font-semibold tabular text-foreground">{pct}</span>
        {label && <span className="-mt-0.5 text-[10px] uppercase tracking-widest text-muted-foreground">{label}</span>}
      </div>
    </div>
  );
}

export default ReliabilityRing;